import { useEffect, useState } from 'react';

import { cn } from '@/lib/cn';
import { fmt, texts } from '@/lib/texts';

export interface CountdownProps {
  to: Date | string;
  /** Что показать, когда момент прошёл */
  passedLabel?: string;
  className?: string;
}

/** Остаток времени: «2 д 4 ч», «3 ч 10 мин», «12 мин», «Сейчас». */
export function formatRemaining(ms: number): string {
  if (ms <= 0) return texts.countdown.now;
  const totalMin = Math.floor(ms / 60_000);
  const d = Math.floor(totalMin / 1440);
  const h = Math.floor((totalMin % 1440) / 60);
  const m = totalMin % 60;
  if (d > 0) return fmt(texts.countdown.days, { d, h });
  if (h > 0) return fmt(texts.countdown.hours, { h, m });
  return fmt(texts.countdown.minutes, { m: Math.max(m, 1) });
}

/** Обратный отсчёт до сбора или дедлайна оплаты. Обновляется раз в 30 секунд. */
export function Countdown({ to, passedLabel = texts.countdown.passed, className }: CountdownProps) {
  const target = typeof to === 'string' ? new Date(to).getTime() : to.getTime();
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 30_000);
    return () => window.clearInterval(id);
  }, []);

  const remaining = target - now;
  const passed = remaining < -60_000;

  return (
    <span className={cn('num font-semibold', passed && 'text-muted', className)} aria-live="polite">
      {passed ? passedLabel : formatRemaining(remaining)}
    </span>
  );
}
